import { render, staticRenderFns } from "./MatchMini.vue?vue&type=template&id=e363d8f2&scoped=true&lang=pug"
import script from "./MatchMini.vue?vue&type=script&lang=js"
export * from "./MatchMini.vue?vue&type=script&lang=js"
import style0 from "./MatchMini.vue?vue&type=style&index=0&id=e363d8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e363d8f2",
  null
  
)

export default component.exports